import React, { Component } from 'react'
import AuthApi from '@softwaredev_cegeka/auth-api'
import { PermissionContext } from 'src/components/auth/PermissionContext'
import { UserDataContext } from 'src/components/auth/withAuth'

class Permission extends Component {
    static contextType = UserDataContext

    constructor(props) {
        super(props)
        this.apiClient = null
        this.state = {
            hasCustomerAccess: false,
            username: null,
            organization_id: null,
            permissions: [],
            isAllowed: permission => {
                return isAllowed(this.state.permissions, permission)
            },
            isAnyAllowed: permissions => {
                return isAnyAllowed(this.state.permissions, permissions)
            },
            isAllAllowed: permissions => {
                return isAllAllowed(this.state.permissions, permissions)
            },
        }
    }

    /**
     * Customer entity item can only be showed if a user has multiple tenants or,
     * in case of some Cegeka users which only have 1 customer: Cegeka, they have the read all permission
     * @returns {*}
     */
    hasCustomerAccess(response = null) {
        if (response?.data.tenants.length > 1) {
            return true
        }
        return !this.context.isCustomer
    }

    async fetchTenants() {
        try {
            const response = await this.apiClient.fetchTenants({
                username: this.context.data.username,
            })
            this.setState({
                hasCustomerAccess: this.hasCustomerAccess(response),
                username: this.context.data.username,
                permissions: this.context.permissions,
            })
        } catch (e) {
            console.error(e)
        }
    }

    componentDidMount() {
        if (!this.apiClient) {
            this.apiClient = new AuthApi()
        }
        this.fetchTenants()
    }

    componentDidUpdate(prevProps, prevState) {
        const { isCustomer, username } = this.context.data
        if (prevState.username !== username || isCustomer) {
            // Changed user or organisation: determine hasCustomerAccess again
            this.fetchTenants()
        }
    }

    render() {
        return (
            <PermissionContext.Provider value={this.state}>
                {this.props.children}
            </PermissionContext.Provider>
        )
    }
}

function isAllowed(userPermissions, permission) {
    if (!userPermissions?.length) {
        return false
    }

    const invert = permission.startsWith('!')
    if (invert) {
        return !userPermissions.includes(permission.substring(1))
    }
    return userPermissions.includes(permission)
}

function isAnyAllowed(userPermissions, permissions) {
    return permissions.some(permission =>
        isAllowed(userPermissions, permission)
    )
}

function isAllAllowed(userPermissions, permissions) {
    return permissions.every(permission =>
        isAllowed(userPermissions, permission)
    )
}

export default Permission
